@if (picker.previews.length) {
  <div class="ap" [attr.data-count]="picker.previews.length">
    @for (item of picker.previews; track item.url; let i = $index) {
      <div class="sf-attach-preview ap-item">
        @if (item.type === 'image') {
          <img [src]="item.url" alt="" />
        } @else {
          <video [src]="item.url" controls></video>
        }
        <button
          type="button"
          class="sf-attach-remove"
          [attr.aria-label]="'Remove ' + (item.type === 'image' ? 'photo ' + (i + 1) : 'video')"
          (click)="picker.removeAt(i)">&times;</button>
      </div>
    }
  </div>
}
